import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'which_of_the_following_elements_are_referenced_in_written_job_d'

export const dataPointDefinition = {
  retracedId: 'which_of_the_following_elements_are_referenced_in_written_job_d',
  name: 'Which of the following elements are referenced in written job descriptions or job applications?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'RACE_ETHNIC_GROUP_SKIN_COLOR',
      text: 'Race / Ethnic Group / Skin Color',
      externalIds: [
        {
          id: 'disc-1--1-1x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'YES_NO',
        text: "Are written job descriptions or job application forms that reference an applicant's race / ethnic group / skin color in line with applicable legal requirements?",
        externalIds: [
          {
            id: 'rh-dis-3',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'SEX_GENDER',
      text: 'Sex / Gender',
      externalIds: [
        {
          id: 'disc-1--1-2x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'YES_NO',
        text: "Are written job descriptions or job application forms that reference an applicant's sex or gender in line with legal requirements?",
        externalIds: [
          {
            id: 'rh-dis-4',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'RELIGION',
      text: 'Religion',
      externalIds: [
        {
          id: 'disc-1--1-3x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'YES_NO',
        text: "Are written job description or job application forms that reference an applicant's religion in line with legal requirements?",
        externalIds: [
          {
            id: 'rh-dis-5',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'POLITICAL_OPINION',
      text: 'Political Opinion',
      externalIds: [
        {
          id: 'disc-1--1-4x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'YES_NO',
        text: "Are written job description or job application forms that reference an applicant's political opinion in line with legal requirements?",
        externalIds: [
          {
            id: 'rh-dis-6',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'NATIONAL_EXTRACTION',
      text: 'National Extraction',
      externalIds: [
        {
          id: 'disc-1--1-5x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'YES_NO',
        text: "Are written job description or job application forms that reference an applicant's national extraction in line with legal requirements?",
        externalIds: [
          {
            id: 'rh-dis-7',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'SOCIAL_ORIGIN',
      text: 'Social Origin',
      externalIds: [
        {
          id: 'disc-1--1-6x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'YES_NO',
        text: "Are written job description or job application forms that reference an applicant's social origin in line with legal requirements?",
        externalIds: [
          {
            id: 'rh-dis-8',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'DISABILITY',
      text: 'Disability',
      externalIds: [
        {
          id: 'disc-1--1-7x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SELECT',
        text: "Are written job description or job application forms that reference an applicant's disability in line with legal requirements?",
        externalIds: [
          {
            id: 'rh-dis-9',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'HIV_AIDS_STATUS_REAL_OR_PERCEIVED_',
      text: 'HIV / AIDS Status (real or perceived)',
      externalIds: [
        {
          id: 'disc-1--1-8x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SELECT',
        text: "Are written job description or job application forms that reference an applicant's HIV / AIDS status in line with legal requirements?",
        externalIds: [
          {
            id: 'rh-dis-10',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'SEXUAL_ORIENTATION',
      text: 'Sexual Orientation',
      externalIds: [
        {
          id: 'disc-1--1-9x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SELECT',
        text: "Are written job description or job application forms that reference an applicant's sexual orientation in line with legal requirements?",
        externalIds: [
          {
            id: 'rh-dis-11',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'PREGNANCY_MATERNITY_STATUS',
      text: 'Pregnancy / Maternity Status',
      externalIds: [
        {
          id: 'disc-1--1-10x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'YES_NO',
        text: "Are written job description or job application forms that reference an applicant's pregnancy / maternity status in line with legal requirements?",
        externalIds: [
          {
            id: 'rh-dis-12',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'MARITAL_STATUS',
      text: 'Marital Status',
      externalIds: [
        {
          id: 'disc-1--1-11x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SELECT',
        text: "Are written job description or job application forms that reference an applicant's marital status in line with legal requirements?",
        externalIds: [
          {
            id: 'rh-dis-13',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'AGE',
      text: 'Age',
      externalIds: [
        {
          id: 'disc-1--1-12x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SELECT',
        text: "Are written job description or job application forms that reference an applicant's age in line with legal requirements?",
        externalIds: [
          {
            id: 'rh-dis-14',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'NATIONALITY_FOREIGN_MIGRANT_WORKER_STATUS',
      text: 'Nationality / Foreign Migrant Worker Status',
      externalIds: [
        {
          id: 'disc-1--1-13x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SELECT',
        text: "Are written job description or job application forms that reference an applicant's nationality/foreign migrant status in line with legal requirements?",
        externalIds: [
          {
            id: 'rh-dis-15',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'FAMILY_RESPONSIBILITIES',
      text: 'Family responsibilities',
      externalIds: [
        {
          id: 'rh-dis-16x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SELECT',
        text: "Are written job descriptions or job application forms that reference an applicant's family responsibilities in line with legal requirements?",
        externalIds: [
          {
            id: 'rh-dis-17',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'disc-1--1-14x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'disc-1--1-14f',
            version: '1.3',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'RACE_ETHNIC_GROUP_SKIN_COLOR',
                'SEX_GENDER',
                'RELIGION',
                'POLITICAL_OPINION',
                'NATIONAL_EXTRACTION',
                'SOCIAL_ORIGIN',
                'DISABILITY',
                'HIV_AIDS_STATUS_REAL_OR_PERCEIVED_',
                'SEXUAL_ORIENTATION',
                'PREGNANCY_MATERNITY_STATUS',
                'MARITAL_STATUS',
                'AGE',
                'NATIONALITY_FOREIGN_MIGRANT_WORKER_STATUS',
                'FAMILY_RESPONSIBILITIES',
                'OTHER',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'rh-dis-2',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 5140,
  sectionId: '2.2.5',
  impactArea: 'Discrimination, Violence or Harassment',
  impactAreaId: 'DISCRIMINATION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
